import api from './api';

/**
 * 客户关系分析服务
 */
const customerRelationshipService = {
  /**
   * 获取所有成员的客户关系概览
   * @param {string} startDate - 开始日期 (YYYY-MM-DD)
   * @param {string} endDate - 结束日期 (YYYY-MM-DD)
   * @returns {Promise<Array>} 成员关系概览列表
   */
  getAllMembersOverview: async (startDate, endDate) => {
    try {
      const params = {};
      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }

      const response = await api.get('/wework/customer/relationship/members/overview', { params });
      return response.data;
    } catch (error) {
      console.error('获取成员客户关系概览失败:', error);
      throw error;
    }
  },

  /**
   * 获取标签统计数据（支持日期范围、标签组过滤、排除标签）
   * @param {object} params - 查询参数
   * @param {string} params.startDate - 开始日期 (YYYY-MM-DD)
   * @param {string} params.endDate - 结束日期 (YYYY-MM-DD)
   * @param {Array<number>} params.tagGroupIds - 标签组ID列表
   * @param {Array<number>} params.excludeTagIds - 排除的标签ID列表
   * @returns {Promise<Array>} 标签统计列表
   */
  getTagStatistics: async (params = {}) => {
    try {
      const queryParams = {};
      if (params.startDate) queryParams.startDate = params.startDate;
      if (params.endDate) queryParams.endDate = params.endDate;
      if (params.tagGroupIds && params.tagGroupIds.length > 0) {
        queryParams.tagGroupIds = params.tagGroupIds.join(',');
      }
      if (params.excludeTagIds && params.excludeTagIds.length > 0) {
        queryParams.excludeTagIds = params.excludeTagIds.join(',');
      }

      const response = await api.get('/tags/statistics', { params: queryParams });
      return response.data;
    } catch (error) {
      console.error('获取标签统计失败:', error);
      throw error;
    }
  },

  /**
   * 获取标签组及其子标签列表
   * @returns {Promise<Array>} [{groupId, groupName, tags: [{id, name}]}]
   */
  getTagGroupsWithTags: async () => {
    try {
      const response = await api.get('/tags/statistics/groups-with-tags');
      return response.data;
    } catch (error) {
      console.error('获取标签组列表失败:', error);
      throw error;
    }
  }
};

export default customerRelationshipService;
